// Structural type so both DOM and React keyboard events qualify.
interface FindShortcutKeyEvent {
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  key: string;
}

// toLowerCase: CapsLock yields "F". !shiftKey: Ctrl/Cmd+Shift+F is a distinct
// chord (e.g. VS Code's search-in-files) that must pass through to the host.
export function isFindShortcut(e: FindShortcutKeyEvent): boolean {
  return (e.ctrlKey || e.metaKey) && !e.shiftKey && e.key.toLowerCase() === "f";
}

// Shift is deliberately not checked: Shift+G means find-previous, so callers
// read e.shiftKey for direction. toLowerCase: Shift/CapsLock yield "G".
export function isFindNextShortcut(e: FindShortcutKeyEvent): boolean {
  return (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "g";
}
